export function backgroundClasses(open?: boolean) {
  return `hover:bg-[#ee8408] focus:bg-[#ee8408] ${open ? 'bg-[#ee8408]' : 'bg-orange-500'}`;
}
